import { render, staticRenderFns } from "./SellersPaymentHistory.vue?vue&type=template&id=2aa4bbb5"
import script from "./SellersPaymentHistory.vue?vue&type=script&lang=js"
export * from "./SellersPaymentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports